export const MODE_GCP_REQUEST_UI_ACTIVE_NAIL_SELECTED =
  "MODE_GCP_REQUEST_UI_ACTIVE_NAIL_SELECTED";
export const selectActiveNail = (nailId: string): IAction<string> => ({
  payload: nailId,
  type: MODE_GCP_REQUEST_UI_ACTIVE_NAIL_SELECTED,
});

const MODE_GCP_REQUEST_UI_GCP_VISIBILITY_ENABLED =
  "MODE_GCP_REQUEST_UI_GCP_VISIBILITY_ENABLED";
export const enableGCPVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_GCP_VISIBILITY_ENABLED,
});

const MODE_GCP_REQUEST_UI_QC_VISIBILITY_ENABLED =
  "MODE_GCP_REQUEST_UI_QC_VISIBILITY_ENABLED";
export const enableQCVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_QC_VISIBILITY_ENABLED,
});

const MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_ENABLED =
  "MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_ENABLED";
export const enableArchiveVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_ENABLED,
});

const MODE_GCP_REQUEST_UI_QC_VISIBILITY_TOGGLED =
  "MODE_GCP_REQUEST_UI_QC_VISIBILITY_TOGGLED";
export const toggleQCVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_QC_VISIBILITY_TOGGLED,
});

const MODE_GCP_REQUEST_UI_GCP_VISIBILITY_TOGGLED =
  "MODE_GCP_REQUEST_UI_GCP_VISIBILITY_TOGGLED";
export const toggleGCPVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_GCP_VISIBILITY_TOGGLED,
});

export const MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_TOGGLED =
  "MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_TOGGLED";
export const toggleArchiveVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_TOGGLED,
});

export const MODE_GCP_REQUEST_UI_FAKE_GCPS_GROUP_TOGGLED =
  "MODE_GCP_REQUEST_UI_FAKE_GCPS_GROUP_TOGGLED";
export const toggleFakeGcpsGroupVisibility = (): IAction<void> => ({
  type: MODE_GCP_REQUEST_UI_FAKE_GCPS_GROUP_TOGGLED,
  payload: null,
});

const MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_DISABLED =
  "MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_DISABLED";
export const disableArchiveVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_DISABLED,
});

const MODE_GCP_REQUEST_UI_GCP_VISIBILITY_DISABLED =
  "MODE_GCP_REQUEST_UI_GCP_VISIBILITY_DISABLED";
export const disableGCPVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_GCP_VISIBILITY_DISABLED,
});

const MODE_GCP_REQUEST_UI_QC_VISIBILITY_DISABLED =
  "MODE_GCP_REQUEST_UI_QC_VISIBILITY_DISABLED";
export const disableQCVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_QC_VISIBILITY_DISABLED,
});

const MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN =
  "MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN";
export const hideFlightMarkerActionsMenu = (): IAction<void> => ({
  type: MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN,
  payload: undefined,
});

const MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_OPENED =
  "MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_OPENED";
export const openFlightMarkerActionsMenu = (): IAction<void> => ({
  type: MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_OPENED,
  payload: undefined,
});

const MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_TOGGLED =
  "MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_TOGGLED";
export const toggleFlightMarkerActionsMenu = (): IAction<void> => ({
  type: MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_TOGGLED,
  payload: undefined,
});

const MODE_GCP_REQUEST_UI_ACTIVE_NAIL_WAS_RESET =
  "MODE_GCP_REQUEST_UI_ACTIVE_NAIL_WAS_RESET";
export const resetActiveNail = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_ACTIVE_NAIL_WAS_RESET,
});

const MODE_GCP_REQUEST_UI_NEW_NAIL_ADDITION_TOGGLED =
  "MODE_GCP_REQUEST_UI_NEW_NAIL_ADDITION_TOGGLED";
export const toggleNewNailAddition = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_NEW_NAIL_ADDITION_TOGGLED,
});

const MODE_GCP_REQUEST_UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED =
  "MODE_GCP_REQUEST_UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED";
export const toggleGCPMailComposerVisibility = (): IAction<void> => ({
  payload: null,
  type: MODE_GCP_REQUEST_UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED,
});

const MODE_GCP_REQUEST_UI_FLIGHT_MARKER_LABELS_TOGGLED =
  "MODE_GCP_REQUEST_UI_FLIGHT_MARKER_LABELS_TOGGLED";
export const toggleGCPFlightMarkerLabels = (): IAction<void> => ({
  type: MODE_GCP_REQUEST_UI_FLIGHT_MARKER_LABELS_TOGGLED,
  payload: null,
});

export interface IModeGcpRequestUi {
  qcGroupIsVisible: boolean;
  gcpGroupIsVisible: boolean;
  fakeGcpGroupIsVisible: boolean;
  archiveGroupIsVisible: boolean;
  activeFlightMarkerId: string;
  flightMarkerActionsMenuIsVisible: boolean;
  mailComposerGCPIsVisible: boolean;
  showFlightMarkerLabelsIsOn: boolean;
}

const defaultState: IModeGcpRequestUi = {
  gcpGroupIsVisible: true,
  qcGroupIsVisible: true,
  fakeGcpGroupIsVisible: true,
  archiveGroupIsVisible: false,
  activeFlightMarkerId: null,
  flightMarkerActionsMenuIsVisible: false,
  mailComposerGCPIsVisible: false,
  showFlightMarkerLabelsIsOn: false,
};

export default function modeGcpRequestReducer(
  state: IModeGcpRequestUi = defaultState,
  action: IAction<any>,
): IModeGcpRequestUi {
  switch (action.type) {
    case MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_OPENED:
      return {
        ...state,
        flightMarkerActionsMenuIsVisible: true,
      };
    case MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN:
      return {
        ...state,
        flightMarkerActionsMenuIsVisible: false,
      };
    case MODE_GCP_REQUEST_UI_FLIGHT_MARKER_ACTIONS_MENU_TOGGLED:
      return {
        ...state,
        flightMarkerActionsMenuIsVisible: !state.flightMarkerActionsMenuIsVisible,
      };
    case MODE_GCP_REQUEST_UI_GCP_VISIBILITY_TOGGLED:
      return {
        ...state,
        gcpGroupIsVisible: !state.gcpGroupIsVisible,
      };
    case MODE_GCP_REQUEST_UI_GCP_VISIBILITY_ENABLED:
      return {
        ...state,
        gcpGroupIsVisible: true,
      };
    case MODE_GCP_REQUEST_UI_GCP_VISIBILITY_DISABLED:
      return {
        ...state,
        gcpGroupIsVisible: false,
      };
    case MODE_GCP_REQUEST_UI_QC_VISIBILITY_TOGGLED:
      return {
        ...state,
        qcGroupIsVisible: !state.qcGroupIsVisible,
      };
    case MODE_GCP_REQUEST_UI_FAKE_GCPS_GROUP_TOGGLED:
      return {
        ...state,
        fakeGcpGroupIsVisible: !state.fakeGcpGroupIsVisible,
      };
    case MODE_GCP_REQUEST_UI_QC_VISIBILITY_ENABLED:
      return {
        ...state,
        qcGroupIsVisible: true,
      };
    case MODE_GCP_REQUEST_UI_QC_VISIBILITY_DISABLED:
      return {
        ...state,
        qcGroupIsVisible: false,
      };
    case MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_TOGGLED:
      return {
        ...state,
        archiveGroupIsVisible: !state.archiveGroupIsVisible,
      };
    case MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_ENABLED:
      return {
        ...state,
        archiveGroupIsVisible: true,
      };
    case MODE_GCP_REQUEST_UI_ARCHIVE_VISIBILITY_DISABLED:
      return {
        ...state,
        archiveGroupIsVisible: false,
      };
    case MODE_GCP_REQUEST_UI_ACTIVE_NAIL_SELECTED:
      return {
        ...state,
        activeFlightMarkerId: action.payload,
      };
    case MODE_GCP_REQUEST_UI_ACTIVE_NAIL_WAS_RESET:
      return {
        ...state,
        activeFlightMarkerId: null,
      };
    case MODE_GCP_REQUEST_UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED:
      return {
        ...state,
        mailComposerGCPIsVisible: !state.mailComposerGCPIsVisible,
      };
    case MODE_GCP_REQUEST_UI_FLIGHT_MARKER_LABELS_TOGGLED:
      return {
        ...state,
        showFlightMarkerLabelsIsOn: !state.showFlightMarkerLabelsIsOn,
      };
    default:
      return state;
  }
}
